import { schema } from '@Schema/schema';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { entityViewConfig } from '@utils/entityViewConfig';
import { APP_PATHS, PAGE_PATHS } from '../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/tickets/$')({
  validateSearch: zodValidator(schema.TICKETS),
  beforeLoad: ({ search }) => {
    const { ticketCategory: x = [] } = search;
    const ticketCategory = x[0];
    const ticketApp = ticketCategory && ticketCategory !== entityViewConfig.Ticket.app ? APP_PATHS.DETECTIONS : APP_PATHS.VULNERABILITIES;
    const page = ticketApp.toLowerCase() === entityViewConfig.Ticket.app.toLowerCase() ? PAGE_PATHS.TICKETS : PAGE_PATHS.INCIDENTS;
    const pathname = window.location.pathname.split('/')?.toSpliced(2, 1, ticketApp, page).join('/');
    throw redirect({ to: pathname, search: true });
  },
});
